module.exports = __webpack_public_path__ + "static/img/110003.4c653127.png";